/**
 * Created by manuel on 11/15/16.
 */
import { Component, OnInit } from '@angular/core';
import { Device } from 'src/app/model/pbx.class';
import { PBXService } from 'src/app/services/pbx.service';
import { IPbxUser } from 'voxloud-types/dist/models';

import { SessionDid } from '../../model/did.class';
import { AccountService } from '../shell/account.service';
import { SessionService } from '../shell/session.service';
import { UIDid } from './dids.model';
import { DidsService } from './dids.service';

@Component({
  selector: 'app-dids',
  templateUrl: './dids.component.html',
  styleUrls: ['./dids.component.scss'],
})
export class DidsComponent implements OnInit {
  user: IPbxUser | null = null;
  device: Device | null = null;
  session = this.sessionService.current;
  account = this.Account.current;
  dids: UIDid[] = this.didsService.getCachedDids();
  outboundDid: SessionDid = this.session.outboundNumber;
  countryId: number = this.session.companyId;
  usersLoading = false;
  usersError = false;

  constructor(
    private sessionService: SessionService,
    private Account: AccountService,
    private didsService: DidsService,
    private pbxService: PBXService
  ) {}

  ngOnInit() {
    this.loadUsers();
  }

  loadUsers() {
    // TODO: replace with data from new API https://voverc.atlassian.net/browse/DEV-5760
    this.usersLoading = true;
    this.usersError = false;

    this.pbxService.getUsers(this.session.pbxId).subscribe(
      (res: IPbxUser[]) => {
        this.user = res.find((user) => user.email === this.session.email) ?? null;
        this.usersLoading = false;
      },
      () => {
        this.usersLoading = false;
        this.usersError = true;
      }
    );
  }

  setOutboundDid(did: UIDid) {
    // TODO: replace with data from new API https://voverc.atlassian.net/browse/DEV-5760
    if (this.dids.some((d) => d.loading)) return;
    if (!this.user) {
      if (!this.usersLoading) {
        did.error = true;
      }

      return;
    }
    if (did.id === this.outboundDid.didId) return;

    did.error = false;
    did.loading = true;

    this.pbxService.getDevices(this.session.pbxId, this.user.id).subscribe(
      (res: Device[]) => {
        this.device = res.find((device) => device.username === this.account.installId) ?? null;
        if (this.device && this.user) {
          this.didsService
            .setOutboundDid(this.session.pbxId, this.device.id, this.user.id, did.number)
            .then(() => {
              const outboundDid = this.session.dids.find((d) => d.number === did.number);
              if (outboundDid) {
                this.sessionService.current.outboundNumber = outboundDid;
                this.outboundDid = outboundDid;
              }
              did.loading = false;
            })
            .catch(() => {
              did.loading = false;
              did.error = true;
            });
        } else {
          did.loading = false;
          did.error = true;
        }
      },
      () => {
        did.loading = false;
        did.error = true;
      }
    );
  }
}
